import { isArray } from 'util';
import { ArticleCam } from '../article-cam';
import { ArticleCamFileBuilder } from './article-cam-file.builder';

export class ArticleCamBuilder {
  static fromJson(json) {
    return (json)
      ? new ArticleCam(
        json.hash,
        json.observations,
        ArticleCamFileBuilder.fromList(json.camFiles)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ArticleCamBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/article-cam.builder.ts